import React from "react"
import ReactSwipe from "react-swipe"
import classnames from "classnames"
import './styles.scss';

export default class Carousel extends React.Component {
  next = () => {
    this.refs.swipe.next();
  }

  previous = () => {
    this.refs.swipe.prev();
  }

  render() {
    const variantClassNames =
      (this.props.variants || []).map(it => `carousel--${it}`);

    return (
      <div role="alert" className={classnames("carousel", variantClassNames)}>
        <button
          aria-label={"Previous"}
          className="carousel__nav-button carousel__nav-button--left"
          onClick={this.previous} onKeyPress={this.previous}>
            <span className='icon-arrow-med-left'>Previous</span>
        </button>

        <ReactSwipe
          swipeOptions={{ startSlide: this.props.startSlide }}
          ref='swipe'
        >
          {this.props.slides.map(({ img, custom }, i) => {
            if(custom) {
              return (
                <div className="carousel__slide" key={i}>
                  {custom}
                </div>
              );
            }

            return (
              <div className={classnames('carousel__slide', {'carousel__slide--with-caption': img.caption})} key={i}>
                <img src={img.src} className="carousel__slide-img" />
                {img.caption && <p className="carousel__slide-caption">{img.caption}</p>}
              </div>
            );
          })}
        </ReactSwipe>

        <button
          aria-label={"Next"}
          className="carousel__nav-button carousel__nav-button--right"
          onClick={this.next} onKeyPress={this.next}>
            <span className='icon-arrow-med-right'>Next</span>
        </button>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./client/components/Carousel/index.js